import { CardFace, Modal } from './parts';
import { categoryDefs } from '../game/cardMeta';
import { useT } from '../i18n';
import type { Card } from '../game/types';

/** Popup describing a single card (opened from equipped gear or the discard). */
export function CardInfo({ card, onClose }: { card: Card; onClose: () => void }) {
  const t = useT();
  const cat = categoryDefs.find((c) => c.kinds.includes(card.kind));
  return (
    <Modal onClose={onClose}>
      <div className="col center" style={{ gap: 14 }}>
        <div className="row between" style={{ width: '100%' }}>
          <h2 className="h2">{t.card.name[card.kind]}</h2>
          <button className="link" onClick={onClose}>{t.player.close}</button>
        </div>
        <CardFace card={card} disabled />
        {cat && (
          <span className="tag" style={{ color: cat.color }}>{t.categories[cat.key]}</span>
        )}
        <p className="mono-dim" style={{ textAlign: 'center', lineHeight: 1.5, margin: 0 }}>
          {t.card.desc[card.kind]}
        </p>
      </div>
    </Modal>
  );
}
